import React from 'react';
import { Link } from 'react-router-dom';
import useAuth from '../../auth/UseAuth';
import Swal from 'sweetalert2';
import { isUndNullEmp, getLanguageObj, navSetting, getResponse, getRolesType, sendMessageCloseCurrentWindowAsync, settings, styles, getUserRoles } from '../../helpers/main';
import { GlobalFormats } from '../../classess/main/globalFormats';
import { User } from '../../classess/user/user';

const { app, backend, html, icons, images, labels, messages } = settings;

const currentMethod = 'Menu';

export default function Menu({
    viewName = '',
    process = '',
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const currentViewName = !isUndNullEmp({ data: viewName, subMethod: currentMethod })?.result ? viewName : '';
    const currentProcess = !isUndNullEmp({ data: process, subMethod: currentMethod })?.result ? process : '';

    const userRole = !isUndNullEmp({ data: auth?.user?.role, subMethod: currentMethod })?.result ?
        auth?.userRole({ languageId: languageObj?.id, subMethod: currentMethod })?.result : settings?.roles?.anonymous;

    let userRoles = getRolesType();
    userRoles = getUserRoles({ userRole: userRole, subMethod: currentMethod })?.result;
    //#endregion variables

    //#region methods
    const signOutShowModelAsync = async ({
        e = null,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'signOutShowModelAsync';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();
            const { isConfirmed } = await Swal.fire({
                icon: settings?.react.sweetAlert2.messages.types.warning,
                title: labels?.warning[languageObj?.id],
                html: messages?.areYouSureToLogOut[languageObj?.id],
                confirmButtonColor: settings?.colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true,
                cancelButtonColor: settings?.colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                customClass: {
                    // popup: 'shadow-lg border-0 rounded-lg',
                    // title: 'text-dark font-weight-bold'
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                }
            });

            if (isConfirmed) {
                response = auth?.logout({ subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) {
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: response?.msgText,
                        urlGoTo: app?.backend.urlHome,
                        auth: auth,
                        languageId: languageObj?.id
                    });
                    return response;
                }
                // window.location.href = '/';
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: response.msgText,
                urlGoTo: app?.backend.urlHome,
                auth: auth,
                languageId: languageObj?.id,
            });
        }
    }
    //#endregion methods

    return (
        <aside className='main-sidebar sidebar-light-primary border-right shadow-sm transition-all' style={{ backgroundColor: '#b0b7bf' }}>

            {/* Brand Logo */}
            <a href='/' className='brand-link border-bottom-0 py-3 text-center' style={{ backgroundColor: '#b0b7bf' }}>
                <img src={images?.appLogo} alt='appLogo' className='brand-image img-circle border-0 shadow-sm' style={{ opacity: '.9', float: 'none' }} />
                <span className='brand-text font-weight-bold ml-2 text-dark' style={{ letterSpacing: '0.5px', fontSize: '0.8rem' }}>{app?.title}</span>
            </a>

            {/* Sidebar */}
            <div className='sidebar px-2'>

                {/* Sidebar user panel */}
                {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                    <div className='user-panel mt-4 pb-4 mb-4 d-flex align-items-center border-bottom-0 bg-white shadow-sm px-2 mx-1' style={{ borderRadius: '10px' }}>
                        <div className='image'>
                            <a href={backend?.urls?.profile}>
                                <img id={html?.controls?.main?.menu?.profile?.img?.id}
                                    style={{ ...styles.leftMenuUserPicture, width: '40px', height: '40px', objectFit: 'cover' }}
                                    src={User?.getPictureFullPath({ picture: auth?.user?.urlPicture, subMethod: currentMethod })?.result}
                                    className='img-circle border shadow-sm'
                                    alt='User' />
                            </a>
                        </div>
                        <div className='info ml-2'>
                            <a href={backend?.urls?.profile} className='d-block font-weight-bold text-dark text-sm'>
                                {`${auth?.user?.firstName || ''} ${auth?.user?.lastName || ''}`}
                            </a>
                            <small className='text-muted text-uppercase' style={{ fontSize: '0.65rem' }}>{userRole}</small>
                        </div>
                    </div>
                ) : (<div></div>
                )}

                {/* SidebarSearch Form */}
                <div className='form-inline mb-4 px-1'>
                    <div className='input-group w-100 shadow-none' data-widget='sidebar-search'>
                        <input className='form-control form-control-sidebar bg-light border-0 py-2'
                            type='search'
                            placeholder={labels?.search?.[languageObj?.id] || 'Search'}
                            aria-label='Search'
                            style={{ borderRadius: '5px 0 0 5px' }} />
                        <div className='input-group-append'>
                            <button className='btn btn-sidebar bg-light border-0' style={{ borderRadius: '0 5px 5px 0' }}>
                                <i className='fas fa-search fa-fw text-muted' />
                            </button>
                        </div>
                    </div>
                </div>

                {/* Sidebar Menu */}
                <nav className='mt-2'>
                    <ul className='nav nav-pills nav-sidebar flex-column nav-child-indent nav-flat nav-compact'
                        data-widget='treeview' role='menu' data-accordion='false'>

                        {/* Home Group */}
                        <li className={`${navSetting?.navItem} ${currentViewName === app?.views?.main?.home ? 'menu-open' : ''}`}>
                            <a href='#/' className={`nav-link ${currentViewName === app?.views?.main?.home ? 'active shadow-sm' : 'text-muted'}`}>
                                <i className='nav-icon fas fa-home' />
                                <p>
                                    {labels?.home?.[languageObj?.id]}
                                    <i className={icons?.fasFa?.angleLeftRight} />
                                </p>
                            </a>
                            <ul className='nav nav-treeview mt-1'>
                                <li className={navSetting?.navItem}>
                                    <a href='/' className={`nav-link ${currentProcess === app?.views?.main?.home ? 'active' : ''}`}>
                                        <i className='far fa-circle nav-icon text-xs' />
                                        <p className='text-sm'>{labels?.home?.[languageObj?.id]}</p>
                                    </a>
                                </li>
                            </ul>
                        </li>

                        {/* Dynamic Management Sections */}
                        {(!userRoles?.isAnonymous) && (
                            <>
                                <li className='nav-header text-muted text-uppercase small font-weight-bold mt-4 mb-2 px-3'>
                                    {labels?.management?.[languageObj?.id] || 'Management'}
                                </li>

                                {/* Purchases */}
                                {(!userRoles?.isAnalyst && !userRoles?.isService) && (
                                    <li className={`${navSetting?.navItem} ${currentViewName === app?.views?.purchases?.billToPay ? 'menu-open' : ''}`}>
                                        <a href='#/' className={`nav-link ${currentViewName === app?.views?.purchases?.billToPay ? 'active shadow-sm' : 'text-muted'}`}>
                                            <i className={`nav-icon ${icons?.fasFa?.fileInvoice}`} />
                                            <p>{labels?.purchases?.[languageObj?.id]}<i className={icons?.fasFa?.angleLeftRight} /></p>
                                        </a>
                                        <ul className='nav nav-treeview mt-1'>
                                            <li className={navSetting?.navItem}>
                                                <a href={backend?.urls?.sales} className={`nav-link ${currentProcess === app?.views?.purchases?.billToPay ? 'active' : ''}`}>
                                                    <i className='far fa-circle nav-icon text-xs' />
                                                    <p className='text-sm'>{labels?.billToPay?.[languageObj?.id]}</p>
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                )}

                                {/* Payments, Requirements, etc (similar blocks follow the logic) */}
                                {(!userRoles?.isService) && (
                                    <>
                                        {/* Payments */}
                                        <li className={`${navSetting?.navItem} ${currentViewName === app?.views?.paymentInformations?.paymentInformations ? 'menu-open' : ''}`}>
                                            <a href='#/' className={`nav-link ${currentViewName === app?.views?.paymentInformations?.paymentInformations ? 'active shadow-sm' : 'text-muted'}`}>
                                                <i className={`nav-icon ${icons?.fasFa?.creditCard}`} />
                                                <p>{labels?.paymentInformation?.[languageObj?.id]}<i className={icons?.fasFa?.angleLeftRight} /></p>
                                            </a>
                                            <ul className='nav nav-treeview mt-1'>
                                                <li className={navSetting?.navItem}>
                                                    <a href={backend?.urls?.paymentInformations} className={`nav-link ${currentProcess === app?.views?.paymentInformations?.paymentInformations ? 'active' : ''}`}>
                                                        <i className='far fa-circle nav-icon text-xs' />
                                                        <p className='text-sm'>{labels?.index?.[languageObj?.id]}</p>
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>

                                        {/* Requirements */}
                                        <li className={`${navSetting?.navItem} ${currentViewName === app?.views?.requirements?.requirements ? 'menu-open' : ''}`}>
                                            <a href='#/' className={`nav-link ${currentViewName === app?.views?.requirements?.requirements ? 'active shadow-sm' : 'text-muted'}`}>
                                                <i className={`nav-icon ${icons?.fasFa?.fileContract}`} />
                                                <p>{labels?.requirements?.[languageObj?.id]}<i className={icons?.fasFa?.angleLeftRight} /></p>
                                            </a>
                                            <ul className='nav nav-treeview mt-1'>
                                                <li className={navSetting?.navItem}>
                                                    <a href={backend?.urls?.requirements} className={`nav-link ${currentProcess === app?.views?.requirements?.requirements ? 'active' : ''}`}>
                                                        <i className='far fa-circle nav-icon text-xs' />
                                                        <p className='text-sm'>{labels?.index?.[languageObj?.id]}</p>
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>
                                    </>
                                )}

                                {/* Core Services */}
                                <li className={`${navSetting?.navItem} ${currentViewName === app?.views?.services?.services ? 'menu-open' : ''}`}>
                                    <a href='#/' className={`nav-link ${currentViewName === app?.views?.services?.services ? 'active shadow-sm' : 'text-muted'}`}>
                                        <i className={`nav-icon ${icons?.fasFa?.th}`} />
                                        <p>{labels?.services?.[languageObj?.id]}<i className={icons?.fasFa?.angleLeftRight} /></p>
                                    </a>
                                    <ul className='nav nav-treeview mt-1'>
                                        {[
                                            { url: backend?.urls?.backupReviews, label: labels?.backupReviews?.[languageObj?.id], process: app?.views?.backupReviews?.backupReviews },
                                            { url: backend?.urls?.dataCenters, label: labels?.dataCenter?.[languageObj?.id], process: app?.views?.dataCenter?.dataCenter },
                                            { url: backend?.urls?.parameters, label: labels?.devices?.[languageObj?.id], process: app?.views?.parameters?.parameters },
                                            { url: backend?.urls?.domainHostings, label: labels?.domainHostings?.[languageObj?.id], process: app?.views?.domainHosting?.domainHosting },
                                            { url: backend?.urls?.remoteConnections, label: labels?.remoteConnections?.[languageObj?.id], process: app?.views?.remoteConnections?.remoteConnections },
                                        ].map((item, idx) => (
                                            <li key={idx} className={navSetting?.navItem}>
                                                {/* <a href={item.url} className={`nav-link ${currentProcess === item.process ? 'active font-weight-bold' : ''}`}> */}
                                                <a href={item.url} className={currentProcess === item?.process ? `${navSetting?.navLinkActive} active font-weight-bold` : navSetting?.navLink}>
                                                    <i className='far fa-circle nav-icon text-xs' />
                                                    <p className='text-sm'>{item.label}</p>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </li>

                                {/* SystemAccess */}
                                {(!userRoles?.isService) && (
                                    <li className={`${navSetting?.navItem} ${currentViewName === app?.views?.systemAccesses?.systemAccesses ? 'menu-open' : ''}`}>
                                        <a href='#/' className={`nav-link ${currentViewName === app?.views?.systemAccesses?.systemAccesses ? 'active shadow-sm' : 'text-muted'}`}>
                                            <i className={`nav-icon ${icons?.fasFa?.usersCog}`} />
                                            <p>{labels?.systemAccesses?.[languageObj?.id]}<i className={icons?.fasFa?.angleLeftRight} /></p>
                                        </a>
                                        <ul className='nav nav-treeview mt-1'>
                                            <li className={navSetting?.navItem}>
                                                <a href={backend?.urls?.systemAccesses} className={`nav-link ${currentProcess === app?.views?.systemAccesses?.systemAccesses ? 'active' : ''}`}>
                                                    <i className='far fa-circle nav-icon text-xs' />
                                                    <p className='text-sm'>{labels?.index?.[languageObj?.id]}</p>
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                )}
                            </>
                        )}

                        {/* Administrator Section */}
                        {(userRoles?.isAdmin) && (
                            <>
                                <li className='nav-header text-muted text-uppercase small font-weight-bold mt-4 mb-2 px-3'>
                                    {labels?.administrator?.[languageObj?.id] || 'Admin'}
                                </li>
                                <li className={`${navSetting?.navItem} ${currentViewName === app?.views?.settings?.settings ? 'menu-open' : ''}`}>
                                    <a href='#/' className={`nav-link ${currentViewName === app?.views?.settings?.settings ? 'active shadow-sm' : 'text-muted'}`}>
                                        <i className={`nav-icon ${icons?.fasFa?.userShield} text-primary`} />
                                        <p>{labels?.administrator?.[languageObj?.id]}<i className={icons?.fasFa?.angleLeftRight} /></p>
                                    </a>
                                    <ul className='nav nav-treeview mt-1 pb-2'>
                                        {[
                                            { url: backend?.urls?.countries, label: labels?.countries?.[languageObj?.id], process: app?.views?.countries?.countries },
                                            { url: backend?.urls?.companies, label: labels?.companies?.[languageObj?.id], process: app?.views?.companies.companies },
                                            { url: backend?.urls?.customers, label: labels?.customers?.[languageObj?.id], process: app?.views?.customers.customers },
                                            { url: backend?.urls?.status, label: labels?.status?.[languageObj?.id], process: app?.views?.status?.status },
                                            { url: backend?.urls?.types, label: labels?.types?.[languageObj?.id], process: app?.views?.types?.types },
                                            { url: backend?.urls?.users, label: labels?.users?.[languageObj?.id], process: app?.views?.users?.users },
                                            { url: backend?.urls?.analysts, label: labels?.analysts?.[languageObj?.id], process: app?.views?.analysts?.analysts },
                                            { url: backend?.urls?.devices, label: labels?.devices?.[languageObj?.id], process: app?.views?.devices?.devices },
                                            { url: backend?.urls?.configurations, label: labels?.configurations?.[languageObj?.id], process: app?.views?.configurations?.configurations },
                                            { url: `${backend?.urls?.notifications}/toasts`, label: labels?.notifications?.[languageObj?.id], process: app?.views?.notifications?.toast?.toast },
                                        ].map((item, idx) => (
                                            <li key={idx} className={navSetting?.navItem}>
                                                <a href={item.url} className={`nav-link ${currentProcess === item.process ? 'active' : ''}`}>
                                                    <i className='far fa-circle nav-icon text-xs opacity-50' />
                                                    <p className='text-sm'>{item.label}</p>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                            </>
                        )}

                        {/* Session Footer */}
                        <li className='nav-header text-muted text-uppercase small font-weight-bold mt-4 mb-2'>
                            {labels?.session?.[languageObj?.id] || 'Session'}
                        </li>
                        <li className={navSetting?.navItem}>
                            {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                                <Link to='/logOff' onClick={(e) => signOutShowModelAsync({ e })} className='nav-link text-danger'>
                                    <i className='fas fa-sign-out-alt nav-icon opacity-75' />
                                    <p className='font-weight-bold'>{labels?.logOff[languageObj?.id]}</p>
                                </Link>
                            ) : (
                                <a className='nav-link text-primary' href={backend?.urls?.login}>
                                    <i className='fas fa-sign-in-alt nav-icon opacity-75' />
                                    <p className='font-weight-bold'>{labels?.login?.[languageObj?.id]}</p>
                                </a>
                            )}
                        </li>
                    </ul>
                </nav>
            </div>
        </aside>
    );
}